import { render, staticRenderFns } from "./sede.vue?vue&type=template&id=915f553a&"
import script from "./sede.vue?vue&type=script&lang=js&"
export * from "./sede.vue?vue&type=script&lang=js&"
import style0 from "./sede.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports